import React from 'react';

interface SliderStepInterface {
  title: string;
  customClass: string;
  inpuRangeLabel: string;
  max: number;
  min: number;
  onClick: () => void;
  onChange: (string) => void;
  value: number;
}

export const SliderStep: React.FC<SliderStepInterface> = ({
  customClass,
  inpuRangeLabel,
  max,
  min,
  onChange,
  onClick,
  title,
  value,
}) => {
  return (
    <section className={`step ${customClass}`}>
      <h2 className="section-h2">{title}</h2>
      <div className="section-container">
        <div className="evaluated-property-value-label" id="range-input">
          {inpuRangeLabel}
        </div>
        <div className="slide-container">
          <input
            className="slider"
            max={max}
            min={min}
            onChange={e => {
              onChange(e.target.value);
            }}
            type="range"
            value={value}
          />
        </div>
        <div>
          <button className="btn-cta mortgage-btn" onClick={onClick} type="button">
            <span className="btn-label">NEXT</span>
          </button>
        </div>
      </div>
    </section>
  );
};
